import { useQuery, QueryResult, OperationVariables, QueryHookOptions } from '@apollo/client';
import * as AuthQuery from 'graphql/auth.graphql';
import { SessionQuery } from 'api/data/user/types';

export default function useUserSession(options?: QueryHookOptions): QueryResult<SessionQuery, OperationVariables> {
  return useQuery<SessionQuery>(AuthQuery.Session, options);
}
